import React from 'react';
import { NavLink } from 'react-router-dom'
import logo from '../images/logo.png'

const Header2 = () => {

    return (
        <div id="#" className="header absolute-top ">
            <div className="text-center">
                <NavLink to="/"><img
                    src={logo}
                    className="navbar-brand header-image"
                    alt="Logo"
                /></NavLink>

            </div>
        </div>
    );
}

export default Header2;